// extracted by mini-css-extract-plugin
export var button = "_5w-7";
export var buttonRow = "_5w-6";
export var fadeIn = "_5w-1";
export var gradient = "_5w-0";
export var panel = "_5w-2";
export var panelIn = "_5w-3";
export var subtitle = "_5w-5";
export var title = "_5w-4";